import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';
import styles from 'styles/TenderForm.module.css';

interface TenderAsideProps {
  wrapperClass?: string;
  isSwimmingOrganization: boolean;
}

const TenderAside: FunctionComponent<TenderAsideProps> = ({
  wrapperClass,
  isSwimmingOrganization,
}) => {
  const { t } = useTranslation('organizations');

  const swimmingBullets = [
    'tenderForm.aside.bulletPoints.first',
    'tenderForm.aside.bulletPoints.second',
    'tenderForm.aside.bulletPoints.swimmingThird',
    'tenderForm.aside.bulletPoints.fourth',
  ];

  const defaultBullets = [
    'tenderForm.aside.bulletPoints.first',
    'tenderForm.aside.bulletPoints.second',
    'tenderForm.aside.bulletPoints.defaultThird',
    'tenderForm.aside.bulletPoints.fourth',
  ];

  const bulletPoints = isSwimmingOrganization
    ? swimmingBullets
    : defaultBullets;

  return (
    <aside
      className={classNames(wrapperClass, 'mb-8 h-max space-y-4 bg-white')}
    >
      <div className="h-max space-y-6 rounded-md border p-6">
        {bulletPoints.map((text, idx) => (
          <div key={`points-${idx}`} className={styles['number-point-wrapper']}>
            <span className={styles['number-point']}>{+idx + 1}</span>
            <span>{t(text)}</span>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default TenderAside;
